"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const mark_boolean_value_1 = require("../../molecules/mark-boolean-value");
const typography_1 = require("../../shared/typography");
const tags_1 = require("../../atoms/tags");
const icons_1 = require("../../atoms/icons");
// TODO: TS - This implementation is a joke... Extended return type to match with implementation
const analiseValue = (value) => {
    switch (value) {
        case "true":
            return true;
        case "false":
            return false;
        case "null":
            return null;
        default:
            return value;
    }
};
exports.default = (value, isDay = false) => {
    if (value === "")
        return (0, jsx_runtime_1.jsx)("div", {}, void 0);
    if (parseInt(value) >= 80) {
        return isDay ? ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: (0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: `${value}%` }, void 0) }, void 0)) : ((0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: `${value}%` }, void 0));
    }
    const parsedValue = analiseValue(value);
    if (typeof parsedValue === "string") {
        return (0, jsx_runtime_1.jsx)(typography_1.P, { children: value }, void 0);
    }
    return (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: value, size: "sm" }, void 0);
};
//# sourceMappingURL=checkProgressValue.js.map